import { atom } from "jotai";
import type { LibraryItemDetailPage_LibraryItemFragment } from "./LibraryItemDetailPageContainer.generated";

/**
 * The open detail page's item. Kept apart from the page container so the app
 * shell (the left-nav opt-in card) can read it without bundling every detail
 * page.
 */
export const libraryItemAtom = atom<
  LibraryItemDetailPage_LibraryItemFragment | undefined
>(undefined);

export const libraryItemTitleAtom = atom(
  (get) => get(libraryItemAtom)?.name.en,
  (get, set, newTitle: string) => {
    const currentLibraryItem = get(libraryItemAtom);
    if (currentLibraryItem) {
      set(libraryItemAtom, {
        ...currentLibraryItem,
        name: {
          ...currentLibraryItem.name,
          en: newTitle,
        },
      });
    }
  },
);
